import KubernetesDeploymentFeedback from "~/components/K8sStatusFeedback/KubernetesDeploymentFeedback";
export default KubernetesDeploymentFeedback;
